import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import { Grid } from '@material-ui/core';
import { LinkCTA, LinkInLine, LinkRouter } from '../../components/Link';
import FavouriteStoreView from './FavouriteStoreView';
import { getAppCfg, getContacts } from '../../utils/common';
import crmservices from '../../wsclient/';
import { paths } from '../../../portal.router.config';
const styles = theme => ({

});
function FavouriteStoreController(props){
    const [showLoading, onShowLoading] = useState(false);
    const [confirm, setConfirm] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    })
    const [stores, setStores] = useState([]);

    

    useEffect(() => {
        onLoadStore();
    }, []);

    const onLoadStore = async () => {
        onShowLoading(true);
        try {
            const contact = getContacts();
            var result = await crmservices.rewards.getOrgLocations({ countries: contact.country_agreement });
            if (result.code == 'OK') {
                setStores(result.data.content);
            }
        } catch (error) {
            console.log("get all merchant exception:", error);
        }
        onShowLoading(false);
    }


    const showAlert = (status, message, title, children) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
            children: children,
            });
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
            });
    }
    const onSelectStore = async (favourite_shop) => {
        console.log("favourite_shop:", favourite_shop)
        onShowLoading(true);
        try {
            const result = await crmservices.contacts.addContactPreferences(favourite_shop.id, 'REWARDS');
            console.log("addContactPreferences result:", result)
            props.history.push(paths.home);
        } catch (error) {
            console.log('add favourite shop exception:', error);
            props.history.push(paths.home);
        }
        onShowLoading(false);
    }
    const onSkip = () => {
        props.history.push(paths.home);
    }

    return (
        <div>
            <FavouriteStoreView
                stores={stores}
                showAlert = {showAlert}
                onShowLoading = {onShowLoading}
                onSelectStore={onSelectStore}
                onSkip={onSkip}
                />
            <Loading showLoading={showLoading} />
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}


export default withStyles(styles)(withTranslation()(FavouriteStoreController));